module.exports = __webpack_public_path__ + "img/User_location.9165ecd3.png";